// 仪器管理路由
import Layout from "@/layout";

const baseDataRoute = [
  {
    path: '/base',
    component: Layout,
    redirect: '/base/checkItemSet',
    name: 'base',
    meta: {
      title: '基础数据',
      icon: 'tree',
      roles: ['manager']
    },
    children: [{
      path: 'checkItemSet',
      component: () => import('@/views/base/checkItemSet'),
      name: 'checkItemSet',
      meta: {
        title: '项目设定',
        icon: 'checkitem-set'
      }
    },
    {
      path: 'checkItem',
      component: () => import('@/views/base/checkItem'),
      name: 'checkItem',
      meta: {
        title: '检测项目',
        icon: 'check-project'
      }
    },
    {
      path: 'testMethod',
      component: () => import('@/views/base/testMethod'),
      name: 'testMethod',
      meta: {
        title: '检测方法',
        icon: 'check-project'
      }
    },
    {
      path: 'checkStandard',
      component: () => import('@/views/base/checkStandard'),
      name: 'checkStandard',
      meta: {
        title: '检验标准',
        icon: 'check-standard'
      }
    },
    {
      path: 'device',
      component: () => import('@/views/base/device'),
      name: 'device',
      meta: {
        title: '检测仪器',
        icon: 'device'
      },
      hidden: true
    },
    {
      path: 'checktype',
      component: () => import('@/views/base/checkType'),
      name: 'checktype',
      meta: {
        title: '检测类别',
        icon: 'leibie'
      }
    },
    {
      path: 'sampleType',
      component: () => import('@/views/base/sampleType'),
      name: 'sampleType',
      meta: {
        title: '样品类型',
        icon: 'check-project'
      },
      hidden: true
    },
    {
      path: 'deviceType',
      component: () => import('@/views/base/deviceType'),
      name: 'deviceType',
      meta: {
        title: '设备类型',
        icon: 'leibie'
      },
      hidden: true
    },
    {
      path: 'store',
      component: () => import('@/views/base/store'),
      name: 'store',
      meta: {
        title: '档口列表',
        icon: 'icon26'
      },
      hidden: true
    },
    {
      path: 'area',
      component: () => import('@/views/base/area'),
      name: 'area',
      meta: {
        title: '区域列表',
        icon: 'area'
      },
      hidden: true
    },
    {
      path: 'part',
      component: () => import('@/views/base/part'),
      name: 'part',
      meta: {
        title: '片区列表',
        icon: 'area'
      },
      hidden: true
    },
    {
      path: 'market',
      component: () => import('@/views/base/market'),
      name: 'market',
      meta: {
        title: '市场列表',
        icon: 'market'
      },
      hidden: true
    },
    {
      path: 'product',
      component: () => import('@/views/base/product'),
      name: 'product',
      meta: {
        title: '产品列表',
        icon: 'product'
      }
    },
    {
      path: 'productCategory',
      component: () => import('@/views/base/productCategory'),
      name: 'productCategory',
      meta: {
        title: '产品类别',
        icon: 'leibie'
      }
    },
    {
      path: 'pesticide',
      component: () => import('@/views/base/pesticide'),
      name: 'pesticide',
      meta: {
        title: '农药类别',
        icon: 'leibie'
      }
    }
    ]
  }
]
export default baseDataRoute



// WEBPACK FOOTER //
// ./src/router/modules/baseData.js